module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-60x60-1ac4ca026447e64335c9412aa6bb7a30.png";